/* eslint-disable */
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
export * from './page_title.js'
export * from './heading.js'
export * from './page_description.js'
export * from './config_title.js'
export * from './label_api_url.js'
export * from './label_token.js'
export * from './label_lang.js'
export * from './label_primary_color.js'
export * from './label_border_radius.js'
export * from './placeholder_api_url.js'
export * from './placeholder_token.js'
export * from './btn_reset.js'
export * from './status_reset.js'
export * from './account_title.js'
export * from './account_label_name.js'
export * from './account_label_website.js'
export * from './install_title.js'
export * from './btn_download.js'
export * from './archive_description.js'
export * from './install_step_1.js'
export * from './install_step_2.js'
export * from './tab_auto.js'
export * from './tab_manual.js'
export * from './auto_description.js'
export * from './manual_description.js'
export * from './btn_copy.js'
export * from './btn_copied.js'
export * from './snippet_comment.js'
export * from './snippet_your_token.js'
export * from './snippet_destroy_comment.js'
export * from './rooms_title.js'
export * from './rooms_label.js'
export * from './rooms_id_room.js'
export * from './rooms_roomtcode.js'
export * from './rooms_catcode.js'
export * from './rooms_add.js'
export * from './rooms_remove.js'
export * from './rooms_empty_hint.js'
export * from './label_background_color.js'
export * from './label_show_shadow.js'
export * from './label_shadow_on.js'
export * from './label_shadow_off.js'
export * from './label_border_color.js'
export * from './label_show_border.js'
export * from './label_border_on.js'
export * from './label_border_off.js'
export * from './label_separate_dates.js'
export * from './label_separate_dates_on.js'
export * from './label_separate_dates_off.js'
export * from './label_show_book_button.js'
export * from './label_book_button_on.js'
export * from './label_book_button_off.js'
export * from './label_show_pricing.js'
export * from './label_pricing_on.js'
export * from './label_pricing_off.js'
export * from './rooms_install_title.js'
export * from './rooms_install_description.js'
export * from './style_overrides_title.js'
export * from './style_overrides_description.js'
export * from './style_overrides_auto_title.js'
export * from './style_overrides_auto_description.js'
export * from './style_overrides_manual_title.js'
export * from './style_overrides_manual_description.js'
export * from './style_overrides_update_comment.js'